import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ITimelineItem } from "@/typings/Props";
import TimelineItem from "./TimelineItem";
import { theme } from "@/styles/theme";

export default function TimeLine({ ...props }: React.PropsWithChildren<ITimelineItem>) {
  const { t } = useTranslation();
  const data = {
    aboutUs: [
      {
        id: 1,
        headline: t("learn.timeline.bia-innacuracy"),
        title: t("learn.timeline.bia-innacuracy.title"),
        description: t("learn.timeline.bia-innacuracy.desc"),
        image: "/learn/about-us/recognizing-innacurate-BIA-devices.png",
        imgDesc: t("learn.timeline.bia-innacuracy.img-desc"),
      },
      {
        id: 2,
        headline: t("learn.timeline.overcoming-the-limitations"),
        title: t("learn.timeline.overcoming-the-limitations.title"),
        description: t("learn.timeline.overcoming-the-limitations.desc"),
        image: "/learn/about-us/overcoming-limitations.png",
        imgDesc: "1996",
      },
      {
        id: 3,
        headline: t("learn.timeline.launched-the"),
        title: t("learn.timeline.launched-the.title"),
        description: t("learn.timeline.launched-the.desc"),
        image: "/learn/about-us/launched-the.png",
        imgDesc: "2006",
      },
      {
        id: 4,
        headline: t("learn.timeline.the-inbody570"),
        title: t("learn.timeline.the-inbody570.title"),
        description: t("learn.timeline.the-inbody570.desc"),
        image: "/learn/about-us/inbody570.png",
        imgDesc: "2013",
      },
      {
        id: 5,
        headline: t("learn.timeline.the-inbody770"),
        title: t("learn.timeline.the-inbody770.title"),
        description: t("learn.timeline.the-inbody770.desc"),
        image: "/learn/about-us/inbody770.png",
        imgDesc: "2014",
      },
      {
        id: 6,
        headline: t("learn.timeline.if-design-award"),
        title: t("learn.timeline.if-design-award.title"),
        description: t("learn.timeline.if-design-award.desc"),
        image: "/learn/about-us/design-award.png",
        imgDesc: "2015",
      },
      {
        id: 7,
        headline: t("learn.timeline.the-inbody270"),
        title: t("learn.timeline.the-inbody270.title"),
        description: t("learn.timeline.the-inbody270.desc"),
        image: "/products/InBody270_Display.webp",
        imgDesc: "2016",
      },
      {
        id: 8,
        headline: t("learn.timeline.bpbio320"),
        title: t("learn.timeline.bpbio320.title"),
        description: t("learn.timeline.bpbio320.desc"),
        image: "/learn/about-us/bpbio.png",
        imgDesc: "2018",
      },
      {
        id: 9,
        headline: t("learn.timeline.launched-the"),
        title: t("learn.timeline.inbody970-bwa2.0.title"),
        description: t("learn.timeline.inbody970-bwa2.0.desc"),
        image: "/learn/about-us/inbody970.png",
        imgDesc: "2020",
      },
      {
        id: 10,
        headline: t("menu.products.lookingbody-web"),
        title: t("learn.timeline.lookinbody-web.title"),
        description: t("learn.timeline.lookinbody-web.desc"),
        image: "/learn/about-us/WhatsApp-Image-2024-06-24-at-14.01.14.png",
        imgDesc: "2023",
      },
      {
        id: 11,
        headline: t("learn.timeline.our-latest-launch"),
        title: t("learn.timeline.our-latest-launch.title"),
        description: t("learn.timeline.our-latest-launch.desc"),
        image: "/learn/about-us/WhatsApp-Image-2024-06-24-at-14.01.07.jpeg",
        imgDesc: "2024",
      },
    ],
    inbodyTech: [
      {
        id: 1,
        headline: t("learn.timeline.dr-hoffer"),
        title: t("learn.timeline.dr-hoffer.title"),
        description: t("learn.timeline.dr-hoffer.desc"),
        image: "/learn/inbody-tech/InBody-Tech-Resources.jpg",
        imgDesc: "1969",
      },
      {
        id: 2,
        headline: t("learn.timeline.commercialized"),
        title: t("learn.timeline.commercialized.title"),
        description: t("learn.timeline.commercialized.desc"),
        image: "/learn/inbody-tech/InBody_Technology-Commercialized_Impedance_Meter.png",
        imgDesc: "1979",
      },
      {
        id: 3,
        headline: t("learn.timeline.further"),
        title: t("learn.timeline.further.title"),
        description: t("learn.timeline.further.desc"),
        image: "/learn/inbody-tech/InBody_Technology-Further_Improvement.png",
        imgDesc: "1980s",
      },
      {
        id: 4,
        headline: t("learn.timeline.release-of-bia-devices"),
        title: t("learn.timeline.release-of-bia-devices.title"),
        description: t("learn.timeline.release-of-bia-devices.desc"),
        image: "/learn/inbody-tech/InBody_Technology-Release_Of_BIA.png",
        imgDesc: t("learn.timeline.release-of-bia-devices.img-desc"),
      },
      {
        id: 5,
        headline: t("learn.timeline.improving-bia-tech"),
        title: t("learn.timeline.improving-bia-tech.title"),
        description: t("learn.timeline.improving-bia-tech.desc"),
        image: "/learn/inbody-tech/InBody_Technology-Improving_BIA.png",
        imgDesc: "1992",
      },
      {
        id: 6,
        headline: t("learn.timeline.world-first-point"),
        title: t("learn.timeline.world-first-point.title"),
        description: t("learn.timeline.world-first-point.desc"),
        image: "/learn/inbody-tech/InBody_Technology-World_First.png",
        imgDesc: "1996",
      },
    ],
  };

  function dataIndex() {
    const keys = Object.keys(data);
    for (let i: number = 0; keys.length; i++) {
      if (keys[i] == props.tab) {
        return i;
      }
    }
    return -1;
  }

  const index = dataIndex();
  const key = Object.keys(data)[index] as keyof typeof data;
  const tabData = data[key];
  return (
    <TimelineWrapper>
      <Content>
        <Title>{props.children}</Title>
        {tabData.map((data) => {
          return (
            <TimelineItem
              key={data.id}
              headline={data.headline}
              title={data.title}
              description={data.description}
              image={data.image}
              imgDesc={data.imgDesc}
              isLast={tabData.length != data.id}
            />
          );
        })}
      </Content>
    </TimelineWrapper>
  );
}

const TimelineWrapper = styled.div`
  width: 100%;
  padding: 30px 33px;
`;
const Content = styled.div`
  width: 93%;
  height: 100%;
  margin: auto;
  border-top: 2px solid ${theme.colors.primary};
`;
const Title = styled.p`
  margin: 60px 0;
  font-size: 2.9rem;
  font-weight: ${theme.fontWeights.bold};
`;
